import SelectAllController from './select_all_controller'
import { current } from '../helpers'
import { archiveCardCardTablesPath, archiveCardCardTableColumnsPath, archiveCardCardTableColumnCardsPath } from '../routes'

const CARD_TABLES_FRAME_ID = 'archive_cards_card_tables'
const COLUMNS_FRAME_ID = 'archive_cards_columns'
const CARDS_FRAME_ID = 'archive_cards_cards'

export default class extends SelectAllController {
  static targets = [
    'projectSelect', 'cardTableId', 'submitButton', 'buttonCount',
    'projectStep', 'cardTableStep', 'columnStep', 'cardsStep'
  ]

  connect () {
    const ctFrame = document.getElementById(CARD_TABLES_FRAME_ID)
    if (ctFrame) this.initialCardTablesHTML = ctFrame.innerHTML
    const colFrame = document.getElementById(COLUMNS_FRAME_ID)
    if (colFrame) this.initialColumnsHTML = colFrame.innerHTML
    const cardsFrame = document.getElementById(CARDS_FRAME_ID)
    if (cardsFrame) this.initialCardsHTML = cardsFrame.innerHTML
  }

  selectProject () {
    this.resetSubmitButton()
    this.resetColumns()
    this.resetCards()
    this.setStepState(this.columnStepTarget, 'disabled')
    this.setStepState(this.cardsStepTarget, 'disabled')
    if (this.projectId) {
      this.loadCardTables()
      this.setStepState(this.projectStepTarget, 'done')
      this.setStepState(this.cardTableStepTarget, 'active')
    } else {
      this.resetCardTables()
      this.setStepState(this.projectStepTarget, 'active')
      this.setStepState(this.cardTableStepTarget, 'disabled')
    }
  }

  selectCardTable ({ target }) {
    this.resetSubmitButton()
    this.loadColumns(target.value)
    this.resetCards()
    this.setStepState(this.cardTableStepTarget, 'done')
    this.setStepState(this.columnStepTarget, 'active')
    this.setStepState(this.cardsStepTarget, 'disabled')
  }

  selectColumn ({ target }) {
    this.loadCards(target.value)
    this.setStepState(this.columnStepTarget, 'done')
    this.setStepState(this.cardsStepTarget, 'active')
    this.submitButtonVisible = true
    this.submitButtonDisabled = true
  }

  selectCards () {
    this.updateSubmitButtonState()
  }

  toggle (e) {
    super.toggle(e)
    this.updateSubmitButtonState()
  }

  refresh () {
    super.refresh()
    this.updateSubmitButtonState()
  }

  loadCardTables () {
    const frame = document.getElementById(CARD_TABLES_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.cardsGridSkeleton())
    frame.src = archiveCardCardTablesPath(current.account.id, this.projectId)
  }

  loadColumns (cardTableId) {
    const frame = document.getElementById(COLUMNS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.chipsSkeleton())
    frame.src = archiveCardCardTableColumnsPath(current.account.id, this.projectId, cardTableId)
  }

  loadCards (columnId) {
    const frame = document.getElementById(CARDS_FRAME_ID)
    if (!frame) return
    this.showSkeleton(frame, this.listSkeleton())
    frame.src = archiveCardCardTableColumnCardsPath(current.account.id, this.projectId, this.cardTableId, columnId)
  }

  resetCardTables () {
    const frame = document.getElementById(CARD_TABLES_FRAME_ID)
    if (!frame || !this.initialCardTablesHTML) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialCardTablesHTML
  }

  resetColumns () {
    const frame = document.getElementById(COLUMNS_FRAME_ID)
    if (!frame || !this.initialColumnsHTML) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialColumnsHTML
  }

  resetCards () {
    const frame = document.getElementById(CARDS_FRAME_ID)
    if (!frame || !this.initialCardsHTML) return
    frame.removeAttribute('src')
    frame.innerHTML = this.initialCardsHTML
  }

  updateSubmitButtonState () {
    this.submitButtonDisabled = this.checked.length === 0
    this.buttonCountContent = this.checked.length
  }

  // eslint-disable-next-line accessor-pairs
  set buttonCountContent (count) {
    this.buttonCountTarget.textContent = count === 1
      ? '1 card'
      : `${count} cards`
  }

  get cardTableId () {
    return this.cardTableIdTarget.value
  }
}
